import Head from 'next/head'
import { Container, Loading } from 'components/ui'
import { useState, useEffect } from 'react'
import Layout, { Breadcrumb, BreadcrumbProps } from 'components/layout'
import { ProductListView } from 'modules/products/containers'
import { ProductService } from 'modules/products/services'
import parser from 'fazendinha/product'
import { useRouter } from 'next/router'
import { parseCookies } from 'nookies'
import { useMercadinho } from 'hooks/use-mercadinho'
import s from './products.module.css'

const ProdutosIndex = () => {
  const crumbs: BreadcrumbProps['crumbs'] = [{ url: '/', label: 'Produtos' }]
  const router = useRouter()
  const [products, setProducts] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)
  const { setIsMercadinho } = useMercadinho()

  const productService = new ProductService()

  async function getProducts() {
    const cookies = parseCookies()
    const storedZipcode = (cookies.zipcode as never) || null
    const queryCode = router.query.zipcode || null
    const zip = storedZipcode || queryCode || null

    try {
      const productQuery = {
        categories: '',
        page: router.query.page || 1,
        days: router.query.days || '',
        tags: router.query.tags || '',
        orderby: router.query.orderby || 'asc',
        sort: '',
        search: router.query.search || '',
        zipcode: zip || '', // zipcode
      }

      // @ts-ignore
      const productsResponse = await productService.query(productQuery)

      setProducts({
        products: productsResponse.data.data.map((p: any) => parser(p)),
        lastPage: productsResponse.data.meta.last_page,
        category: '',
        search: router.query.search || '',
      })
    } catch (e) {
      //
    } finally {
      setLoading(false)
    }
  }

  if (router.query.search) {
    crumbs.push({ label: `Resultado: ${router.query.search}` })
  }

  const pageTitle = router.query.search ? `Busca por: ${router.query.search}` : 'Produtos'

  const SearchTitle = () => {
    return (
      <>
        Resultados da busca por: <strong>{router.query.search}</strong>
      </>
    )
  }

  useEffect(() => {
    // if (!isEmpty(router.query)) {
    setIsMercadinho(false)
    getProducts()
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router])

  return (
    <Layout>
      <Head>{pageTitle}</Head>
      <Breadcrumb crumbs={crumbs} />
      <Container className={s.root}>
        <div style={{ marginBottom: '12px' }}>
          <img src="/assets/images/produtos/banner-produtos.jpg" alt="produtos" />
        </div>
        <h1 className={s.title}>{router.query.search ? <SearchTitle /> : ''}</h1>
        {loading && <Loading />}
        <ProductListView lastPage={products.lastPage} baseUrl={router.asPath} products={products.products} isSearch />
      </Container>
    </Layout>
  )
}

export default ProdutosIndex
